import axios from '../utils/axios';

export default function getCompaniesWithPendingLogos (adminId, params) {
    params.checkClearBit = 1;
    return axios.get(`/admin/${adminId}/getCompanyDetailsWithPendingLogos`, { params });
}